import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {isEmpty} from "../../../../components/commonmethod/CommonMethod";
import {saveContract} from "../../../../api/asset/AssetContractService";
import Th_title from "../../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../../components/select/SelectComboBoxForCreate";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {cn} from "../../../../shadCn/lib/utils";
import dayjs from "dayjs";
import SimmsInput from "../../../../components/input/SimmsInput";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {onCreateClickListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {AssetSearchFilters} from "../../mng/info/shared/AssetSearchFilters";
import {CacheType} from "../../../../constant/CodeSpecNum";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvReadOnly,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";

export const contractType = [
    {id: "없음", name: "없음"},
    {id: "통합유지보수", name: "통합유지보수"},
    {id: "개별유지보수", name: "개별유지보수"},
    {id: "ACS(인력지원)", name: "ACS(인력지원)"},
    {id: "인프라(콜센터)", name: "인프라(콜센터)"},
];

export const contractClassification = [
    {id: "하자보수(무상)", name: "하자보수(무상)"},
    {id: "유지관리(유상)", name: "유지관리(유상)"}
];

function AssetContractCreate() {
    const platFrom = useSelector(state => state.auth.platFrom);
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [contract, setContract] = useState({
        type: "없음", classification: "하자보수(무상)", requester: user
    });
    const [assets, setAssets] = useState([]);
    const [docs, setDocs] = useState([]);
    const refreshCache = useCacheRefresh();
    const navigate = useNavigate();
    const requireds = ["name", "requester", "company"];
    const dispatch = useDispatch();

    const create = async () => {
        if (requireds.some(e => isEmpty(contract[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        dispatch(apiLoading(true));

        const docFile = [];
        docs.forEach(each => docFile.push(each.object));

        const updatedData = {
            ...contract,
            company: {id: contract.company.id},
            requester: {id: contract.requester.id}
        };

        await saveContract(updatedData, docFile, assets).then(response => {
            if (response.status === 200) {
                handleActiveToast({message: "등록되었습니다."});
                refreshCache(CacheType.contract);
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/asset/contract/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/asset/contract");
                }
            } else if (response.status === 201 || response.status === 202) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 413) {
                handleActiveError({message: "첨부파일 용량이 너무 큽니다."});
            } else {
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="계약 등록"
            meta="신규 계약 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/asset/contract")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                        <DetailPanel title="기본정보">
                            <DetailKvTable>
                                <tbody>
                                <tr>
                                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                                    <DetailKvReadOnly label="수정일시" value=""/>
                                </tr>
                                <tr>
                                    <DetailKvReadOnly label="등록자" value={user.name}/>
                                    <DetailKvReadOnly label="수정자" value=""/>
                                </tr>
                                <tr>
                                    <Th_title title="계약명" colspan={1} className="fieldset-td fieldset-td-input" required auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setContract, "name", v, true)} data={contract.name}/>
                                    </Th_title>
                                    <Th_title title="계약번호" colspan={1} className="fieldset-td fieldset-td-input" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setContract, "number", v, false)} data={contract.number}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="요청자" colspan={1} className="fieldset-td" required auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setContract, "requester", contract.requester, v)}
                                            data={contract.requester}
                                            entity="userAccount"
                                            uniqueKey="requester"
                                        >
                                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                                        </Selector>
                                    </Th_title>
                                    <Th_title title="업체명" colspan={1} className="fieldset-td" required auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setContract, "company", contract.company, v)}
                                            data={contract.company}
                                            entity="company"
                                            uniqueKey="company"
                                        >
                                            <SimmsInputSearch type="TEXT" placeHolder="업체명"/>
                                        </Selector>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="계약구분" colspan={1} className="fieldset-td" auth>
                                        <SelectComboBoxForCreate
                                            target="type"
                                            options={contractType}
                                            data={{data: contract, fnc: setContract}}
                                            defaultValue={contract.type}
                                        />
                                    </Th_title>
                                    <Th_title title="계약종류" colspan={1} className="fieldset-td" auth>
                                        <SelectComboBoxForCreate
                                            target="classification"
                                            options={contractClassification}
                                            data={{data: contract, fnc: setContract}}
                                            defaultValue={contract.classification}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="계약체결일" colspan={3} className="fieldset-td fieldset-td-input" auth>
                                        <SimmsDatePicker
                                            onChange={(v) => dateOnChange(setContract, "contractDate", v, false)}
                                            data={contract.contractDate}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="계약기간" colspan={3} className="fieldset-td fieldset-td-input">
                                        <div className="web-flex asset-detail-date-range">
                                            <SimmsDatePicker
                                                onChange={(v) => dateOnChange(setContract, "contractStartDate", v, false)}
                                                data={contract.contractStartDate}
                                                constraint={{lessThan: contract.contractEndDate && dayjs(contract.contractEndDate)}}
                                                auth
                                            />
                                            <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                            <SimmsDatePicker
                                                onChange={(v) => dateOnChange(setContract, "contractEndDate", v, false)}
                                                data={contract.contractEndDate}
                                                constraint={{largerThan: contract.contractStartDate && dayjs(contract.contractStartDate)}}
                                                auth
                                            />
                                        </div>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="유지보수 요율" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setContract, "rate", v, false)} data={contract.rate}/>
                                    </Th_title>
                                    <Th_title title="유지보수 금액(연간)" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setContract, "price", v, false)} data={contract.price}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="계약정보" colspan={3} className="fieldset-td fieldset-td-input" auth>
                                        <SimmsTextArea
                                            onChange={(v) => inputOnChange(setContract, "etc", v, false)}
                                            data={contract.etc}
                                            style={{width: "100%"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr className="asset-detail-kv-row--auto">
                                    <th>자산목록</th>
                                    <td colSpan={3} className="fieldset-td relative align-top">
                                        <UserSelectionField
                                            layout="inline"
                                            data={assets}
                                            countUnit="개"
                                            chipEntity="asset"
                                            listModalTitle="자산목록"
                                            onRemove={(v) =>
                                                setAssets((prev) => (prev ?? []).filter((asset) => asset.id !== v.id))
                                            }
                                        >
                                            <SearchSelector
                                                auth
                                                multiSelect
                                                variant="compact"
                                                entity="asset"
                                                uniqueKey="assets"
                                                data={assets}
                                                placeHolder="자산명"
                                                onChange={(v) => {
                                                    if (v?.__multiFlat) {
                                                        setAssets(v.__multiFlat);
                                                    }
                                                }}
                                            >
                                                <AssetSearchFilters platFrom={platFrom}/>
                                            </SearchSelector>
                                        </UserSelectionField>
                                    </td>
                                </tr>
                                </tbody>
                            </DetailKvTable>
                        </DetailPanel>
                        }
                        aside={
                        <DetailFilePanel
                            title="첨부"
                            isEditing
                            pendingFiles={{files: docs, setFiles: setDocs}}
                            pendingInputId="contract_create_doc"
                        />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {AssetContractCreate};
